<template>
  <div class="user_info_container_content">
    <div class="title_top_hr">
      <p>
        <i></i>
        <span>我的关注</span>
      </p>
      <el-divider></el-divider>
    </div>
    <div class="my_user_follow_list_box"
    v-loading="listLoading"
    element-loading-text="列表加载中"
    element-loading-spinner="el-icon-loading">
      <div v-if="!listLoading && listData.length === 0" class="my_none">
        <img class="my_none_img" src="../../assets/img/user/myFollowNone.png" alt="关注列表为空"><br/>
        <span class="my_none_user_text">您暂且关注任何用户！</span>
      </div>
      <div v-else>
        <div v-for="(item, index) in listData" :key="item.id" class="my_user_follow_list_item lf">
          <div class="my_user_follow_list_left">
            <img :src="item.portrait" alt="">
          </div>
          <div class="my_user_follow_list_right">
            <div class="my_user_follow_list_info">
              <span class="my_user_follow_list_name" @click="userJump(item.user_id)">
                {{item.user_name}}
              </span>
              <span class="my_user_follow_list_fans">
                {{item.fans_count}} 人关注
              </span>
            </div>
            <!-- <div class="my_user_follow_list_text">
              {{item.content}}
            </div> -->
            <div class="my_user_follow_list_other">
              <span>{{item.live_count}}直播</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{item.article_count}}文章</span>
              <el-divider direction="vertical"></el-divider>
              <span>{{item.video_count}}视频</span>
            </div>
            <div class="my_user_follow_list_btn"
            @mouseenter="followMouseEnter(index)"
            @mouseleave="followMouseLeave(index)"
            @click="followClick(item.user_id, index)">
              <button v-show="item.is_follow === 0"
              class="greenglga_btn"
              >
                <i class="add">+</i>
                <span>关注</span>
              </button>
              <button v-show="item.is_follow === 1"
              :class="followIndex === index ? 'greenglga_btn greenglga_btn_cancle' : 'greenglga_btn greenglga_btn_confirm'"
              >
                <span v-show="followIndex !== index">已关注</span>
                <span v-show="followIndex === index">取消关注</span>
              </button>
            </div>
          </div>
        </div>

      </div>
    </div>
    <el-pagination
        v-if="listData.length > 0"
        background
        layout="prev, pager, next"
        :page-size= "listLimit"
        :total="listNum"
        @current-change = "pageChange">
      </el-pagination>

  </div>
</template>

<script>
export default {
  data () {
    return {
      isdisable: false,
      followIndex: -1,
      listData: [], // 关注列表
      listNum: 0, // 文章总条目
      listLimit: 10, // 列表当前页显示条目数
      listPage: 1, // 列表当前页码
      listLoading: true // 开启加载动画
    }
  },
  created () {
    this.pageChange()
  },
  methods: {
    // 获取数据
    pageChange: function (index) {
      const vueThat = this
      if (index === undefined) {
        vueThat.listPage = 1
      } else {
        vueThat.listPage = index
      }
      const data = {
        limit: vueThat.listLimit,
        page: vueThat.listPage
      }
      vueThat.myApi.getMyfollowList(data).then(function (res) {
        if (res.data.code === 200) {
          vueThat.listLoading = false
          vueThat.listData = res.data.data.follow_list
          vueThat.listNum = res.data.data.count
        }
      })
    },
    // 关注按钮鼠标移入
    followMouseEnter (index) {
      this.followIndex = index
    },
    // 关注按钮鼠标移出
    followMouseLeave (index) {
      this.followIndex = -1
    },
    // 关注按钮点击
    followClick (id, index) {
      const vueThat = this
      vueThat.isdisable = true
      vueThat.followIndex = index
      if (vueThat.listData[index].is_follow === 1) {
        vueThat.myApi.cancelFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.isdisable = false
            vueThat.listData[index].is_follow = 0
          }
        })
      } else {
        vueThat.myApi.addFollow({ user_id: id }).then((res) => {
          if (res.data.code === 200) {
            vueThat.isdisable = false
            vueThat.listData[index].is_follow = 1
          }
        })
      }
    },
    userJump (rid) {
      const routeData = this.$router.resolve({
        path: '/personalCenter/:id',
        query: { id: rid }
      })
      window.open(routeData.href, '_blank')
    }
  }
}
</script>

<style>
</style>
